import { getIsApiPending } from '../../../selectors/eaTravelRates/update';
import { apiTransitionGetExchangeList, getExchangeListSuccess } from '../../../actions/eaTravelRates/update';
import axios from 'axios';
import { getAuthVerifyData } from '../../../selectors/eaTravelRates/auth';

export const exchangeListService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionGetExchangeList.pending());
            try {
                const resp = await getList(store.getState());

                store.dispatch(getExchangeListSuccess(resp.data));
                store.dispatch(apiTransitionGetExchangeList.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionGetExchangeList.failure());
            }
        }
    })();
    return next(action);
};

const getList = async (state) => {
    const loginData = getAuthVerifyData(state);
    try {
        const url = '/om-api/ea-travel-rates/list';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
